import {
  ProductCalculation,
  UnderlyingDataType,
} from 'src/apis/capacity-management/types';
import * as pp from 'src/utils/page-params';

type Options = {
  calculationType?: ProductCalculation;
};

export function usePageParams({ calculationType }: Options) {
  const underlyingDataParam =
    calculationType?.type === 'FIRM_DAY' ||
    calculationType?.type === 'FIRM_WITHINDAY'
      ? 'FDAUIOLI_CAPACITY'
      : 'TECHNICAL_CAPACITY';

  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(5))
      .add(
        pp
          .param('underlyingData')
          .default<UnderlyingDataType>(underlyingDataParam)
          .filter({ label: 'Underlying Data' })
      )
  );
}

export type PageParams = ReturnType<typeof usePageParams>;
